import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService } from "src/app/core/service/http.service";
import { Drug } from "../models/drug";
import { UserIdleService } from 'angular-user-idle';

@Injectable({
  providedIn: "root",
})
export class DrugServiceService {
  constructor(private httpService: HttpService,
    private userIdle: UserIdleService
    ) {
      this.restart()
    }

  GetDrugList(drugDetails: any): Observable<any> {
    return this.httpService.post("pharmacyapi/GetDrugs", drugDetails);
  }
  AddDrug(drugDetails: any): Observable<any> {
    return this.httpService.post("pharmacyapi/AddDrug", drugDetails);
  }
  UpdateDrug(drugDetails: any): Observable<any> {
    return this.httpService.post("pharmacyapi/UpdateDrug", drugDetails);
  }
  DeleteDrug(drugDetails: any): Observable<any> {
    return this.httpService.post("pharmacyapi/DeleteDrug", drugDetails);
  }
  DrugById(drugDetails: any): Observable<any> {
    return this.httpService.post("pharmacyapi/GetDrugById", drugDetails);
  }
  ListDrug(name: string): Observable<Drug[]> {
    return this.httpService.post(`pharmacyapi/GetList`, { name: name });
  }
  restart() {
    this.userIdle.resetTimer();
  }
}
